import { RecommendationPoint } from "./order/RecommendationPoint";

export type Master = {
  products: Product[];
  jobChanges: JobChange[];
  services: Service[];
  operations: Operation[];
  desireToWorks: DesireToWork[];
  qualifications: Qualification[];
  prefectures: Prefecture[];
  workStyles: WorkStyle[];
  banks: Bank[];
  recommendationPoints: RecommendationPoint[];
  offerTypes: OfferType[];
  japaneseHolidays: JapaneseHoliday[];
};
export type Product = {
  id: number;
  name: string;
  slug: string;
  sortNo: number;
  displayWorkerServiceName: string;
  iosAppId: string;
  androidAppId: string;
  workerServices: WorkerService[];
  orderServices: Service[];
  qualifications: Qualification[];
};
export type WorkerService = {
  id: number;
  serviceName: string;
  displayName: string;
};
export type JobChange = {
  level: string;
  id: number;
  slug: string;
  name: string;
  sortNo: number;
};
export type Service = {
  id: number;
  slug: string;
  name: string;
  sortNo: number;
  nameForStaff: string;
  onlyWorkerExperience: boolean;
};
export type Operation = {
  id: number;
  slug: string;
  name: string;
  sortNo: number;
};
export type DesireToWork = {
  id: number;
  slug: string;
  name: string;
  sortNo: number;
};
export type Qualification = {
  id: number;
  slug: string;
  name: string;
  workerServiceId: number;
  isVisible: boolean;
};
export type Prefecture = {
  id: number;
  prefecture: string;
  areaId: number;
  isCaitechTarget: boolean;
  isCaitechPharmacistTarget: boolean;
};
export type WorkStyle = {
  id: number;
  style: string;
};
export type Bank = {
  id: number;
  code: string;
  name: string;
  aliases: string[];
};
export type BankBranch = {
  name: string;
  hiragana: string;
  kana: string;
  roma: string;
};
export type OfferType = {
  id: number;
  slug: string;
  name: string;
  sortNo: number;
};
export type JapaneseHoliday = {
  date: string;
  remarks: string;
};

export const PRODUCT_SLUG_CAITECH_CARE = "caitech_care";
export const PRODUCT_SLUG_CAITECH_PHARMACIST = "caitech_pharmacist";
export const VALID_PRODUCT_SLUGS = [
  PRODUCT_SLUG_CAITECH_CARE,
  PRODUCT_SLUG_CAITECH_PHARMACIST
];
export const CAREER_SEMINAR_OFFER_TYPE_SLUG = "career_seminar";
